module.exports = __webpack_public_path__ + "assets/bcdcd64a409e99d57a878b465fd15a11.svg";